<template>
  <div class="Carousel">
    <div class="imgs">
      <div class="imgsBox" :style="{ left: -current * 750 + 'px', width: 750 * 3 + 'px' }">
        <PreviewImage
          class="img"
          v-for="item in list"
          :key="item.id"
          :src="item.coverImage"
          :hover="false"
          @click="onClick(item)"
        />
      </div>
    </div>
    <div class="cover">
      <div class="box">
        <div class="icon left" @click="prev">
          <img src="@/assets/com/left.svg" />
        </div>
        <div class="icon right" @click="next">
          <img src="@/assets/com/right.svg" />
        </div>
        <div class="content" v-if="list.length">
          <div href="" class="tag" @click="onClickTag(currentData)">{{ getNoticeTagName(currentData.noticeTag) }}</div>
          <h3 :title="currentData.title" @click="onClick(currentData)">{{ currentData.title }}</h3>
          <p @click="onClick(currentData)">{{ getHTMLText(currentData.content) }}</p>
        </div>
        <div class="point">
          <div class="circle" v-if="list.length > 0" :class="{ active: current === 0 }" @mouseenter="current = 0"></div>
          <div class="circle" v-if="list.length > 1" :class="{ active: current === 1 }" @mouseenter="current = 1"></div>
          <div class="circle" v-if="list.length > 2" :class="{ active: current === 2 }" @mouseenter="current = 2"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { getHTMLText, toDetail } from '@/utils'
import routerByNoticeTag, { getNoticeTagName } from '@/utils/noticeTag'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'

const props = defineProps<{
  /** 只显示三个 */
  list: NoticeItem[]
}>()
const current = ref(0)

const currentData = computed(() => {
  return props.list[current.value] || {}
})

function prev() {
  if (current.value <= 0) {
    current.value = props.list.length - 1
  } else {
    current.value--
  }
}
function next() {
  if (current.value >= 2 || props.list.length - 1 < current.value + 1) {
    current.value = 0
  } else {
    current.value++
  }
}

onMounted(() => {
  timeourNext()
})
onBeforeUnmount(() => {
  timeourNext_cancel()
})

const timer = ref()
function timeourNext() {
  timer.value = setTimeout(() => {
    next()
  }, 5 * 1000)
}
function timeourNext_cancel() {
  clearTimeout(timer.value)
}

watch(current, () => {
  timeourNext_cancel()
  timeourNext()
})

function onClickTag(item: NoticeItem) {
  routerByNoticeTag(item.noticeTag)
}

function onClick(item: NoticeItem) {
  toDetail(item)
}
</script>
<style lang="less" scoped>
.Carousel {
  height: 420px;
  position: relative;

  .imgs {
    width: 750px;
    height: 100%;
    background-color: #fff;
    position: absolute;
    left: 0;
    overflow: hidden;
    .imgsBox {
      position: absolute;
      left: 0;
      transition: all 0.2s;
      .img {
        width: 750px;
        height: 420px;
        object-fit: cover;
      }
    }
  }

  .cover {
    width: 840px;
    height: 100%;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, @primary 40%, @primary 100%);
    color: #fff;
    position: absolute;
    right: 0;
    .box {
      position: absolute;
      width: 520px;
      right: 0;
      top: 0;
      bottom: 0;
      .icon {
        width: 30px;
        height: 30px;
        cursor: pointer;
        position: absolute;
        top: calc(50% - 15px);
        &.left {
          left: 0;
        }
        &.right {
          right: 0;
        }
        img {
          width: 22px;
          height: 22px;
        }
      }

      .content {
        position: absolute;
        top: 50px;
        left: 65px;
        width: 370px;
        height: 300px;
        overflow: hidden;
        .tag {
          border-color: #fff;
          color: #fff;
          margin: 0;
          padding: 0 13px;
          width: auto;
          border: 1px solid #dfdfdf;
          font-size: 12px;
          height: 28px;
          line-height: 27px;
          border-radius: 15px;
          display: inline-block;
          text-align: center;
          text-decoration: none;
          transition: all 0.2s;
          cursor: pointer;
          &:hover {
            background: #fff;
            color: @primary;
          }
        }
        h3 {
          color: #fff;
          font-size: 22px;
          padding: 15px 0 13px;
          cursor: pointer;
        }
        p {
          font-size: 12px;
          line-height: 20px;
          color: #dfdfdf;
          cursor: pointer;
          .multi-ellipsis(6);
        }
      }

      .point {
        position: absolute;
        bottom: 40px;
        left: calc(50% - 42px);
        .circle {
          display: inline-block;
          cursor: pointer;
          margin: 0 8px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #fff;
          &.active {
            background: @success;
          }
        }
      }
    }
  }
}
</style>
